import { buildUrl } from "../util/integration"

import {
    authorizedFetch,
} from './http_api';

const INVOICING_PATH = 'invoicing';

function buildInvoicingUrl(path) {
    return buildUrl(`${INVOICING_PATH}/${path}`);
}

function requirePathParameter(value, parameterName) {
    if (
        value === null
        || value === undefined
        || value === ''
    ) {
        throw new TypeError(
            `${parameterName} darf nicht leer sein.`,
        );
    }

    return encodeURIComponent(String(value));
}

export function fetchPurchaserInvoicesAPI(
    accessToken,
    leadId,
) {
    const encodedLeadId = requirePathParameter(
        leadId,
        'leadId',
    );

    return authorizedFetch(
        accessToken,
        buildInvoicingUrl(
            `lead/${encodedLeadId}/role/purchaser`,
        ),
        {
            method: 'GET',
        },
    );
}

export function fetchAuthorInvoicesAPI(
    accessToken,
    leadId,
) {
    const encodedLeadId = requirePathParameter(
        leadId,
        'leadId',
    );

    return authorizedFetch(
        accessToken,
        buildInvoicingUrl(
            `lead/${encodedLeadId}/role/author`,
        ),
        {
            method: 'GET',
        },
    );
}

export function fetchOperatorInvoicesAPI(
    accessToken,
    leadId,
) {
    const encodedLeadId = requirePathParameter(
        leadId,
        'leadId',
    );

    return authorizedFetch(
        accessToken,
        buildInvoicingUrl(
            `lead/${encodedLeadId}/role/operator`,
        ),
        {
            method: 'GET',
        },
    );
}

export function fetchBillingStatusesAPI(
    accessToken,
    userId,
) {
    const encodedUserId = requirePathParameter(
        userId,
        'userId',
    );

    return authorizedFetch(
        accessToken,
        buildInvoicingUrl(
            `user/${encodedUserId}/billing_statuses`,
        ),
        {
            method: 'GET',
        },
    );
}